import React from 'react';
import { Spin } from 'antd';
import { CreateActivityReportModalProps } from './CreateActivityReport';

const LazyCreateActivityReportComponent = React.lazy(
	() => import('./CreateActivityReport')
);

export const AsyncCreateActivityReportModal: React.FC<
	CreateActivityReportModalProps
> = props => {
	return (
		<React.Suspense
			fallback={<Spin data-testid="create-activity-report-modal-loading" />}
		>
			<LazyCreateActivityReportComponent {...props} />
		</React.Suspense>
	);
};
